import { Skeleton } from '@crehana/compass.ui';

export const DetailsSkeleton = () => {
  return (
    <div className=" tw-inline-block tw-w-full ">
      <div
        className="tw-w-full tw-px-3.2 md:tw-px-[9.2rem] lg:tw-px-[32.4rem] tw-py-4 md:tw-py-4.8"
        style={{
          background:
            'linear-gradient(90deg, #F2F3F5 0%, rgba(240, 242, 255, 0.90) 100%)',
        }}
      >
        <div className="tw-flex tw-items-center">
          <Skeleton
            animated
            className="tw-h-5.6 tw-w-5.6  tw-rounded-0.8 tw-mr-1.6"
          />
          <div className="tw-flex tw-flex-col tw-gap-1.2">
            <Skeleton
              animated
              className="tw-h-1.2 tw-w-[9.1rem] tw-rounded-0.8 "
            />
            <Skeleton
              animated
              className="tw-h-1.2 tw-w-[13.8rem] tw-rounded-0.8 "
            />
          </div>
        </div>
        <div className="tw-flex tw-flex-col">
          <Skeleton
            animated
            className="tw-h-[3.9rem] tw-w-1/3 tw-rounded-0.8 tw-mt-2.4 "
          />
          <Skeleton
            animated
            className="tw-h-2.4 tw-w-full tw-rounded-0.8 tw-mt-2.4 "
          />
          <Skeleton
            animated
            className="tw-h-2.4 tw-w-[40%] tw-rounded-0.8 tw-mt-2.4 "
          />
          <Skeleton
            animated
            className="tw-h-4.8 tw-w-[13.8rem] tw-rounded-0.8 tw-mt-4 "
          />
        </div>
      </div>
      <div className="tw-w-full tw-px-3.2 md:tw-px-[9.2rem] lg:tw-px-[32.4rem] tw-py-4 md:tw-py-4.8">
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-full tw-rounded-0.8 tw-mt-2.4 "
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-full tw-rounded-0.8 tw-mt-2.4 "
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-full tw-rounded-0.8 tw-mt-2.4 "
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-full tw-rounded-0.8 tw-mt-2.4 "
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-full tw-rounded-0.8 tw-mt-2.4 "
        />
        <Skeleton
          animated
          className="tw-h-2.4 tw-w-[40%] tw-rounded-0.8 tw-mt-2.4 "
        />
      </div>
    </div>
  );
};
